export class TicketResponse {
    helpDeskTicket: HelpdeskTicketResponse;
    isSuccess: boolean;
}

export class HelpdeskTicketResponse {
    created_at: Date;
    description: string;
    due_by: Date;
    fr_escalated: boolean;
    id: number;
    notes: string[];
    priority: number;
    requester_id: number;
    source: number;
    spam: boolean;
    status: number;
    subject: string;
    updated_at: Date;
    to_emails: string[];
    attachments: string[];
    tags: string[];
    conversations: string[]
}

export class TicketRequest {
    loginEmail: string; 
    attemptCount: number;
    mode: string;
    loginMobileNumber: string;
    username: string; 
    reason: string;
    employeeId: string;  
    companyName: string; 
    policyNumber: string;
    beneficiaryDob: string;
    beneficiaryName: string;
    claimId: string;
    dateOfAdmission: string;
    emailForTicket: string;
    otpContact: string;

}

export enum TicketTypeEnum {
    PolicyNumber = 'POLICY_NUMBER',
    CorporateEmployee = 'CORPORATE_EMPLOYEE',
    ClaimId = 'CLAIM_ID',
    LoginFailure = 'LOGIN_FAILURE',
    NotMyAccount = 'NOT_MY_ACCOUNT'
 }
 
 export enum TicketRouteEnum {
     UserVerify = 'USER_VERIFY',
     UserIdentify = 'USER_IDENTIFY',
     AuthSignin = 'AUTH_SIGNIN'
 }

 export enum TicketHelpMessage {
    ValidationFailure = 'Oh! We regret that we are not able to find your details even after multiple attempts. Allow us some time, and we can get back to you.',
    LoginFailure = 'Oh! We regret that you are not able to login. Allow us some time, and we can get back to you.',
    NotMyAccount = 'Is it correct that this account does not belong to you?" "Would you like to remove the account by creating a ticket?',

 }

 export enum TicketResponseMessage {
    SuccessMessage = 'We have registered the issue faced by you. Our expert will connect with you within 24 hours. Please check your email for reference.',
    FailureMessage = 'Ticket creation failed. Please try again!'
 }